import { render } from "./multiPageBar.vue?vue&type=template&id=2892149b&scoped=true"
import script from "./multiPageBar.vue?vue&type=script&lang=js"
export * from "./multiPageBar.vue?vue&type=script&lang=js"

import "./multiPageBar.vue?vue&type=style&index=0&id=2892149b&scoped=true&lang=css"

import exportComponent from "D:\\PDM-小程序\\HSM_PDM\\PDM_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2892149b"]])

export default __exports__
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTab from 'quasar/src/components/tabs/QTab.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QChip,QAvatar,QIcon,QTooltip,QSpace,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QTab});qInstall(script, 'directives', {ClosePopup});
